<template>
  <div style="max-width:400px">
    <div v-for="(item, key) in items" :key="key">
      <label class="">
        <small class="text-muted">Aufwandsbeschreibung Position {{ key + 1 }}</small>
      </label>
      <div class="d-flex align-items-center mb-3">
        <b-input
          v-model="items[key]"
          :placeholder="'Aufwandsbeschreibung Position ' + (key + 1)"
          @change="sendListToServer"
          :ref="'anteilField-' + key"
          :id="'anteilField-' + key"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        />

        <div>
          <b-icon
            v-if="items.length > 2 && ($root.$user.isPlaner || $root.$user.isAdmin)"
            class="ml-2 action-button"
            icon="trash"
            @click="tryDelete(key)"
          />
        </div>
      </div>
    </div>
    <b-button
      v-if="items.length < MAX_FIELDS && ($root.$user.isPlaner || $root.$user.isAdmin)"
      class="mt-2"
      @click="addItem"
    >
      +
    </b-button>
  </div>
</template>

<script>
import settingsStore from '@/store/Settings';
import projectService from '@/service/ProjectsService';
import AppState from '@/store/App.js';

export default {
  activated() {
    AppState.isLoading = false;
    this.items = settingsStore.settings['PAT_Fields'];
    const itemCount = this.items.length;
    if (itemCount < 3) {
      for (var i = 0; i <= 2 - itemCount; i++) {
        this.items.push('');
      }
      this.sendListToServer();
    }
  },
  data() {
    return {
      items: [''],
      MAX_FIELDS: 10
    };
  },
  methods: {
    addItem() {
      this.items.push('');
      this.sendListToServer();
      this.$nextTick(() => {
        this.$refs['anteilField-' + (this.items.length - 1)][0].focus();
      });
    },
    sendListToServer() {
      projectService.updateProjectSettings(settingsStore.settings).catch(err => {
        this.$showError(this, 'Einstellungen', err.toString());
      });
    },
    deleteItem(key) {
      this.items.splice(key, 1);
      this.sendListToServer();
    },
    tryDelete(index) {
      this.$bvModal
        .msgBoxConfirm(
          'Soll das Feld ' +
            (index + 1) +
            ' ebenfalls aus allen bestehenden Änderungstestaten entfernt werden? (Hinweis: alle Beträge dieses Feldes müssen zuvor auf 0 gesetzt sein)',
          {
            title: 'Änderungstestat - Default Feld ' + (index + 1) + ' löschen',
            okTitle: 'Bestätigen',
            cancelTitle: 'Abbrechen',
            okVariant: 'danger',

            centered: true
          }
        )
        .then(confirmed => {
          if (confirmed) {
            projectService
              .tryDeletePATField(index)
              .then(() => {
                this.deleteItem(index);
                this.$showSuccess(this, 'Einstellungen', 'PÄT Feld erfolgreich gelöscht');
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data);
                else this.$showError(this, err.toString());
              });
          }
        });
    }
  }
};
</script>

<style></style>
